import React, { Dispatch, SetStateAction } from "react";
import { OperationHoursEvent } from "@shared/types";

export const OperationHoursContext = React.createContext<
  | {
      myEvents?: OperationHoursEvent[];
      setMyEvents: Dispatch<SetStateAction<OperationHoursEvent[] | undefined>>;
    }
  | undefined
>(undefined);
